import { Dialog, DialogFooter, DialogType, DefaultButton, PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
import React from "react";

interface DialogRecoveredDataProps {
  isOpen: boolean;
  onClose: () => void;
}

const DialogLicenseValidation: React.FC<DialogRecoveredDataProps> = ({
  isOpen,
  onClose,
}) => (
  <Dialog
    hidden={!isOpen}
    dialogContentProps={{
      type: DialogType.normal,
      title: t("¡Ups! Encontramos algo tuyo"),
    }}
    modalProps={{
      isBlocking: true,
    }}
    onDismiss={onClose}
    maxWidth={450}
  >
    <div style={{ textAlign: 'justify' }}>
      <b>
        {t("No es posible crear la licencia porque existen actividades registradas dentro del rango de fechas seleccionado.")}
      </b>
    </div>
    <div style={{ textAlign: 'justify', marginTop: '20px' }}>
      <span>
        {t("Por favor, elimine o reprograme las actividades correspondientes antes de registrar la licencia.")}
      </span>
    </div>

    <DialogFooter>
      <PrimaryButton onClick={onClose} text={t("OK")} />
    </DialogFooter>
  </Dialog>
);

export default DialogLicenseValidation;